import { ReactNode } from 'react';
import classNames from 'classnames';
import Typography from '@alltrails/core/components/Typography';
import styles from './styles.module.scss';

export type Props = {
  title: ReactNode;
  subtitle: ReactNode;
  text: ReactNode;
  className?: string;
};

const CommunityStat = ({ title = '', subtitle = '', text = '', className = '' }: Props) => (
  <div className={classNames(styles.container, className)}>
    <Typography variant="heading700" className={styles.title} component="div">
      {title}
    </Typography>
    <Typography variant="heading300" className={styles.subtitle} component="div">
      {subtitle}
    </Typography>
    <Typography variant="paragraph200" className={styles.text} component="div">
      {text}
    </Typography>
  </div>
);

export default CommunityStat;
